import React, { useReducer, createContext, useEffect } from 'react';
import { initialState } from './state';
import { reducer } from './reducer';
import {
  DELETE_AACOUNT,
  GET_ACCOUNTS,
  GET_ACCOUNTS_COUNT,
  GET_FACTURAS,
  GET_FACTURAS_COUNT,
  SIGN_IN,
  SIGN_OUT,
} from './types';

export const AppContext = createContext();

const saveToLocalStorage = (name, value) => {
  localStorage.setItem(name, value);
};

const AppReducer = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const signIn = (value) => dispatch({ type: SIGN_IN, value });
  const signOut = () => dispatch({ type: SIGN_OUT });
  const getAccounts = (value) => dispatch({ type: GET_ACCOUNTS, value });
  const getAccountsCount = (value) => dispatch({ type: GET_ACCOUNTS_COUNT, value });
  const getFacturas = (value) => dispatch({ type: GET_FACTURAS, value });
  const getFacturasCount = (value) => dispatch({ type: GET_FACTURAS_COUNT, value });
  const deleteAccount = (value) => dispatch({ type: DELETE_AACOUNT, value });

  useEffect(() => {
    if (state.token && state.role) {
      saveToLocalStorage('token', state.token);
      saveToLocalStorage('role', state.role);
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
    }
  }, [state]);

  return (
    <AppContext.Provider
      value={{ state, signIn, getAccounts, getAccountsCount, deleteAccount, signOut, getFacturas, getFacturasCount }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppReducer;
